export const defaultPaymentParams = {
    paymentType: 'PC',
    'quickpay-form': 'shop',
};
